module.exports = __webpack_public_path__ + "img/datav.88c0d760.png";